//  Copyright (c) 2021 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, func, string } from 'prop-types'
import MenuOption from './MenuOption'
import deleteIcon from 'images/delete.png'
import { useCanUserDeleteProject } from './hooks'

const DeleteProject = props => {
  const {
    hasHighlighted,
    idRoot,
    setModalTemplate,
    sourceForm,
  } = props

  const canUserDelete = useCanUserDeleteProject(sourceForm)

  return (
    <MenuOption
      enabled={canUserDelete && hasHighlighted}
      icon={deleteIcon}
      id={`${idRoot}delete-projects`}
      label={'Delete Project'}
      modalTemplate={'delete-projects'}
      setModalTemplate={setModalTemplate} />
  )
}

DeleteProject.propTypes = {
  hasHighlighted: bool.isRequired,
  idRoot: string.isRequired,
  setModalTemplate: func.isRequired,
  sourceForm: string.isRequired,
}

export default DeleteProject
